import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeExercicioConsultaOrdemCronologicaPagamento: ['exercicio'],
    removeAdministracaoConsultaOrdemCronologicaPagamento: ['administracao'],
    removeSituacaoConsultaOrdemCronologicaPagamento: ['situacao'],
    removePagosConsultaOrdemCronologicaPagamento: ['pagos'],
    removeNomeCredorConsultaOrdemCronologicaPagamento: ['nomeCredor'],
    removeCnpjConsultaOrdemCronologicaPagamento: ['cnpj'],
    removeCpfConsultaOrdemCronologicaPagamento: ['cpf'],
    removeDataVencimentoInicialConsultaOrdemCronologicaPagamento: ['dataVencimentoInicial'],
    removeDataVencimentoFinalConsultaOrdemCronologicaPagamento: ['dataVencimentoFinal'],
    removeDataPagamentoInicialConsultaOrdemCronologicaPagamento: ['dataPagamentoInicial'],
    removeDataPagamentoFinalConsultaOrdemCronologicaPagamento: ['dataPagamentoFinal'],
    removeDataDocumentoInicialConsultaOrdemCronologicaPagamento: ['dataDocumentoInicial'],
    removeDataDocumentoFinalConsultaOrdemCronologicaPagamento: ['dataDocumentoFinal'],
    removeValorLiquidacaoInicialConsultaOrdemCronologicaPagamento: ['valorLiquidacaoInicial'],
    removeValorLiquidacaoFinalConsultaOrdemCronologicaPagamento: ['valorLiquidacaoFinal'],
    removeDocumentoConsultaOrdemCronologicaPagamento: ['documento'],
    removeSerieDocumentoConsultaOrdemCronologicaPagamento: ['serieDocumento'],
    removeGruposConsultaOrdemCronologicaPagamento: ['grupos'],
    removeRecursoConsultaOrdemCronologicaPagamento: ['recurso'],
    removeDestinacaoConsultaOrdemCronologicaPagamento: ['destinacao'],
    removeNumeroContratoConsultaOrdemCronologicaPagamento: ['numeroContrato'],
    removeObjetoContratoConsultaOrdemCronologicaPagamento: ['objetoContrato'],
    setMostraAplicarFiltroConsultaOrdemCronologicaPagamento: [],
    limpaFiltroConsultaOrdemCronologicaPagamento: [],
    aplicarFiltroConsultaOrdemCronologicaPagamento: ['filtro'],
})

const INITIAL_STATE = {
    exercicio: '',
    administracao: [],
    situacao: [],
    pagos: '',
    nomeCredor: '',
    cnpj: '',
    cpf: '',
    dataVencimentoInicial: '',
    dataVencimentoFinal: '',
    dataPagamentoInicial: '',
    dataPagamentoFinal: '',
    dataDocumentoInicial: '',
    dataDocumentoFinal: '',
    valorLiquidacaoInicial: '',
    valorLiquidacaoFinal: '',
    documento: '',
    serieDocumento: '',
    grupos: [],
    recurso: [],
    destinacao: [],
    numeroContrato: '',
    objetoContrato: '',
    mostraAplicarFiltro: false,
}

const removeExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: '', mostraAplicarFiltro: true }
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeSituacao = (state = INITIAL_STATE, action) => {
    state.situacao.splice(state.situacao.indexOf(action.situacao), 1)
    state.situacao = Array.from(state.situacao)
    return { ...state, mostraAplicarFiltro: true }
}

const removePagos = (state = INITIAL_STATE, action) => {
    return { ...state, pagos: '', mostraAplicarFiltro: true }
}
const removeNomeCredor = (state = INITIAL_STATE, action) => {
    return { ...state, nomeCredor: '', mostraAplicarFiltro: true }
}
const removeCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: '', mostraAplicarFiltro: true }
}
const removeCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: '', mostraAplicarFiltro: true }
}
const removeDataVencimentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoInicial: '', mostraAplicarFiltro: true }
}
const removeDataVencimentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoFinal: '', mostraAplicarFiltro: true }
}
const removeDataPagamentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataPagamentoInicial: '', mostraAplicarFiltro: true }
}
const removeDataPagamentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataPagamentoFinal: '', mostraAplicarFiltro: true }
}
const removeDataDocumentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataDocumentoInicial: '', mostraAplicarFiltro: true }
}
const removeDataDocumentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataDocumentoFinal: '', mostraAplicarFiltro: true }
}
const removeValorLiquidacaoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, valorLiquidacaoInicial: '', mostraAplicarFiltro: true }
}
const removeValorLiquidacaoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, valorLiquidacaoFinal: '', mostraAplicarFiltro: true }
}
const removeDocumento = (state = INITIAL_STATE, action) => {
    return { ...state, documento: '', mostraAplicarFiltro: true }
}
const removeSerieDocumento = (state = INITIAL_STATE, action) => {
    return { ...state, serieDocumento: '', mostraAplicarFiltro: true }
}
const removeGrupos = (state = INITIAL_STATE, action) => {
    state.grupos.splice(state.grupos.indexOf(action.grupos), 1)
    state.grupos = Array.from(state.grupos)
    return { ...state, mostraAplicarFiltro: true }
}
const removeRecurso = (state = INITIAL_STATE, action) => {
    state.recurso.splice(state.recurso.indexOf(action.recurso), 1)
    state.recurso = Array.from(state.recurso)
    return { ...state, mostraAplicarFiltro: true }
}
const removeDestinacao = (state = INITIAL_STATE, action) => {
    state.destinacao.splice(state.destinacao.indexOf(action.destinacao), 1)
    state.destinacao = Array.from(state.destinacao)
    return { ...state, mostraAplicarFiltro: true }
}
const removeNumeroContrato = (state = INITIAL_STATE, action) => {
    return { ...state, numeroContrato: '', mostraAplicarFiltro: true }
}
const removeObjetoContrato = (state = INITIAL_STATE, action) => {
    return { ...state, objetoContrato: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_EXERCICIO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeExercicio,
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeAdministracao,
    [Types.REMOVE_SITUACAO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeSituacao,
    [Types.REMOVE_PAGOS_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removePagos,
    [Types.REMOVE_NOME_CREDOR_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeNomeCredor,
    [Types.REMOVE_CNPJ_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeCnpj,
    [Types.REMOVE_CPF_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeCpf,
    [Types.REMOVE_DATA_VENCIMENTO_INICIAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeDataVencimentoInicial,
    [Types.REMOVE_DATA_VENCIMENTO_FINAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeDataVencimentoFinal,
    [Types.REMOVE_DATA_PAGAMENTO_INICIAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeDataPagamentoInicial,
    [Types.REMOVE_DATA_PAGAMENTO_FINAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeDataPagamentoFinal,
    [Types.REMOVE_DATA_DOCUMENTO_INICIAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeDataDocumentoInicial,
    [Types.REMOVE_DATA_DOCUMENTO_FINAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeDataDocumentoFinal,
    [Types.REMOVE_VALOR_LIQUIDACAO_INICIAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeValorLiquidacaoInicial,
    [Types.REMOVE_VALOR_LIQUIDACAO_FINAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeValorLiquidacaoFinal,
    [Types.REMOVE_DOCUMENTO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeDocumento,
    [Types.REMOVE_SERIE_DOCUMENTO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeSerieDocumento,
    [Types.REMOVE_GRUPOS_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeGrupos,
    [Types.REMOVE_RECURSO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeRecurso,
    [Types.REMOVE_DESTINACAO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeDestinacao,
    [Types.REMOVE_NUMERO_CONTRATO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeNumeroContrato,
    [Types.REMOVE_OBJETO_CONTRATO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: removeObjetoContrato,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO]: aplicarFiltro,
})
